import { render, staticRenderFns } from "./showAuditorium.vue?vue&type=template&id=0a3dfe7e&scoped=true"
import script from "./showAuditorium.vue?vue&type=script&lang=js"
export * from "./showAuditorium.vue?vue&type=script&lang=js"
import style0 from "./showAuditorium.vue?vue&type=style&index=0&id=0a3dfe7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dfe7e",
  null
  
)

export default component.exports